'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = normalizeWidth;

require('jquery');

/**
 *  Normalizes boxes to be the same width.
 */
function normalizeWidth($element) {

  if ($element.length > 1) {

    var greatestWidth = 0;

    // Select and loop through the boxes.
    $element.each(function () {

      // If this box is longer than the longest, replace it.
      if ($(this).width() > greatestWidth) {
        greatestWidth = $(this).width();
      }
    });

    // Set the width of all boxes to greatest.
    $element.width(greatestWidth);
  }
}